module.exports = __webpack_public_path__ + "assets/img/8.91c7da15.png";